import { CancellationOptionsQuery } from '@website/types/graphqlOperations';

/**
 * Filter for spaces that can be cancelled
 *
 * @param space Booking Space
 */
export function filterSpaceCancellationPossible(
  space: CancellationOptionsQuery['booking']['spaces'][0],
) {
  return space.cancellationOptions.length > 0;
}
